export default {"src":"/_next/static/media/faq.f44c1dc9.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};